// extracted by mini-css-extract-plugin
export default {"title":"yiSdo","lockIcon":"-ONUf"};